import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loader = ({ fontSize = 24 }) => (
  <Spin indicator={<LoadingOutlined style={{ fontSize: fontSize }} spin />} />
);

export default Loader;
